import { useCallback, useRef } from "react";
import { toast } from "react-toastify";
import type { DocProducerDocument } from "@/views/docproducer";

export const ORDER_LOCK_REASON =
  "Ordrene er låst fordi egnethetsvurderingen er lagt til. Slett egnethetsvurderingen før du legger til, endrer eller sletter ordre.";

/** The suitability document is a snapshot of the orders and must be rebuilt after changes. */
export function useOrderLock(
  documents: readonly Pick<DocProducerDocument, "docType">[]
) {
  const ordersLocked = documents.some(
    (document) =>
      document.docType === "docSuitabilityNew" ||
      document.docType === "suitabilityStatement"
  );
  const lockedRef = useRef(ordersLocked);
  lockedRef.current = ordersLocked;

  const canChangeOrders = useCallback(() => {
    if (!lockedRef.current) return true;
    toast.warning(ORDER_LOCK_REASON);
    return false;
  }, []);

  return { ordersLocked, canChangeOrders };
}
